export default __webpack_public_path__ + "static/media/O-094.3ce51625.png";